import {alias, createModelSchema} from "serializr";
import {BaseObject} from "@/common/BaseObject";
import {UserInfo} from "@/modules/mprofiles/models/props/user_info/UserInfo";
import {ShapInfo} from "@/modules/mprofiles/models/props/shap_info/SnapInfo";
import {UserProfile} from "@/modules/mprofiles/models/props/user_profile/UserProfile";

export class UserModel extends BaseObject {

    constructor() {
        super();
        this._user_info = new UserInfo();
        this._snap_info = new ShapInfo();
        this._user_profile = new UserProfile();
    }

    get user_info() {
        return this._user_info;
    }
    set user_info(value) {
        this._user_info = value;
    }

    get snap_info() {
        return this._snap_info;
    }
    set snap_info(value) {
        this._snap_info = value;
    }

    get user_profile() {
        return this._user_profile;
    }
    set user_profile(value) {
        this._user_profile = value;
    }

    copy() {
        return super.copy();
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new UserModel());
        } else if (target instanceof UserModel) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(UserModel, {
    _user_info: alias("user_info", UserInfo.schema()),
    _snap_info: alias("snap_info", ShapInfo.schema()),
    _user_profile: alias("user_profile", UserProfile.schema()),
});